export type INotification = {
    status?: number | string;
    message: string;
};

export type CustomErrorData = {
    status: number;
    title: string;
    detail?: string;
};

export type ICustomError = {
    error?: CustomErrorData;
};

export function isCustomErrorData(x: unknown): x is CustomErrorData {
    if (typeof x !== "object" || x === null) return false;
    const anyX = x as Record<string, unknown>;
    return (
        typeof anyX.status === "number" &&
        typeof anyX.title === "string" &&
        (anyX.detail === undefined || typeof anyX.detail === "string")
    );
}

export function isICustomError(e: unknown): e is ICustomError & { error: CustomErrorData } {
    if (typeof e !== "object" || e === null) return false;
    const anyE = e as Record<string, unknown>;
    if (!("error" in anyE)) return false;
    return isCustomErrorData(anyE.error);
}

export function getCustomError(e: unknown): CustomErrorData | undefined {
    if (isCustomErrorData(e)) return e;
    if (isICustomError(e)) return e.error;
    return undefined;
}
